/* eslint-disable @typescript-eslint/no-unnecessary-type-constraint */

import { create, StoreApi, UseBoundStore } from "zustand";
import { devtools } from "zustand/middleware";

export type Store<T extends unknown> = UseBoundStore<StoreApi<T>>;

const storeResetFns = new Set<() => void>();

export const resetAllStores = () => {
  storeResetFns.forEach((resetFn) => {
    resetFn();
  });
};

export const createStore = <T extends unknown>(
  fn: (set: StoreApi<T>["setState"], get: StoreApi<T>["getState"], api: StoreApi<T>) => T
): Store<T> => {
  const store = create<T>()(
    devtools(fn, {
      enabled: process.env.NODE_ENV === "development",
    })
  );
  const initialState = store.getState();

  storeResetFns.add(() => {
    store.setState(initialState, true);
  });

  return store;
};
